"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var add_icon_svg_1 = __importDefault(require("@assets/components/user/user-link-table/toolbar/add-icon.svg"));
var actions_1 = __importDefault(require("../../../../actions"));
var ContainedIconButton_1 = __importDefault(require("./templates/ContainedIconButton"));
var minifiedActions_1 = __importDefault(require("../../../CreateUrlModal/helpers/minifiedActions"));
var OvalContainedButton_1 = __importDefault(require("./templates/OvalContainedButton"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    return (0, core_1.createStyles)({
        createLinkButtonContainer: {
            marginLeft: theme.spacing(1.5),
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
        },
    });
});
var CreateLinkButton = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var openCreateUrlModal = function () { return dispatch(actions_1.default.openCreateUrlModal()); };
    var classes = useStyles();
    return (react_1.default.createElement("span", { className: classes.createLinkButtonContainer }, (0, minifiedActions_1.default)() ? (react_1.default.createElement(ContainedIconButton_1.default, { onClick: openCreateUrlModal },
        react_1.default.createElement("img", { src: add_icon_svg_1.default, alt: "Create link" }))) : (react_1.default.createElement(OvalContainedButton_1.default, { onClick: openCreateUrlModal }, "Create link"))));
};
exports.default = CreateLinkButton;
